/* eslint-disable camelcase */
import { App } from 'hydra-data-types';
import { ConnectScreen, MOBILE_OS, REFERRAL_URL_TYPE, USER_TYPE } from '../../constants';

// eslint-disable-next-line no-shadow
export enum AnalyticsEventName {
  a_download_app_clicked = 'a-download_app-clicked',
  a_email_exists = 'a-email-exists',
  a_email_failed = 'a-email-failed',
  a_email_not_exist = 'a-email-not_exist',
  a_email_verified = 'a-email-verified',
  a_link_consent_agreed = 'a-link_consent-agreed',
  a_link_consent_failed = 'a-link_consent-failed',
  a_link_consent_skipped = 'a-link_consent-skipped',
  a_login_failed = 'a-login-failed',
  a_login_succeeded = 'a-login-succeeded',
  a_mindset_authentication_failed = 'a-mindset_authentication-failed',
  a_mindset_authentication_succeeded = 'a-mindset_authentication-succeeded',
  a_password_reset_failed = 'a-password_reset-failed',
  a_password_reset_sent = 'a-password_reset-sent',
  a_sign_token_succeeded = 'a-sign_token-succeeded',
  a_signin_token_failed = 'a-signin_token-failed',
  a_signup_failed = 'a-signup-failed',
  a_signup_succeeded = 'a-signup-succeeded',
  a_start_assessment_clicked = 'a-start_assessment-clicked',
  a_verification_email_resent = 'a-verification_email-resent',
  a_program_card_clicked = 'a-program_card-clicked',
  h_referral_linked = 'h-referral-linked',
  h_referral_url_copied = 'h-referral_url-copied',
  h_referral_url_failed = 'h-referral_url-failed',
  h_referral_url_opened = 'h-referral_url-opened',
  h_screen_viewed = 'h-screen-viewed',
  p_app_opened = 'p-app-opened',
  p_page_not_found = 'p-page-not-found',
}

export type AnalyticsEvent =
  | {
      event: AnalyticsEventName.a_download_app_clicked;
      store: MOBILE_OS.APPLE | MOBILE_OS.GOOGLE;
    }
  | {
      event: AnalyticsEventName.a_email_exists;
      userType: USER_TYPE.PATIENT | USER_TYPE.HCP;
    }
  | {
      event: AnalyticsEventName.a_email_failed;
      userType: USER_TYPE.PATIENT | USER_TYPE.HCP;
      error: string;
    }
  | {
      event: AnalyticsEventName.a_email_not_exist;
      userType: USER_TYPE.PATIENT | USER_TYPE.HCP;
    }
  | {
      event: AnalyticsEventName.a_email_verified;
      userType: USER_TYPE.PATIENT | USER_TYPE.HCP;
    }
  | {
      event: AnalyticsEventName.a_link_consent_agreed;
    }
  | {
      event: AnalyticsEventName.a_link_consent_failed;
      error: string;
    }
  | {
      event: AnalyticsEventName.a_link_consent_skipped;
    }
  | {
      event: AnalyticsEventName.a_login_failed;
      userType: USER_TYPE.PATIENT | USER_TYPE.HCP;
      error: string;
    }
  | {
      event: AnalyticsEventName.a_login_succeeded;
      userType: USER_TYPE.PATIENT | USER_TYPE.HCP;
    }
  | {
      event: AnalyticsEventName.a_mindset_authentication_failed;
      error: string;
    }
  | {
      event: AnalyticsEventName.a_mindset_authentication_succeeded;
    }
  | {
      event: AnalyticsEventName.a_password_reset_failed;
      error: string;
    }
  | {
      event: AnalyticsEventName.a_password_reset_sent;
    }
  | {
      event: AnalyticsEventName.a_sign_token_succeeded;
    }
  | {
      event: AnalyticsEventName.a_signin_token_failed;
      error: string;
    }
  | {
      event: AnalyticsEventName.a_signup_failed;
      userType: USER_TYPE.PATIENT | USER_TYPE.HCP;
      error: string;
    }
  | {
      event: AnalyticsEventName.a_signup_succeeded;
      userType: USER_TYPE.PATIENT | USER_TYPE.HCP;
      attribution?: string;
    }
  | {
      event: AnalyticsEventName.a_start_assessment_clicked;
    }
  | {
      event: AnalyticsEventName.a_verification_email_resent;
    }
  | {
      event: AnalyticsEventName.a_program_card_clicked;
      program: App;
    }
  | {
      event: AnalyticsEventName.h_referral_linked;
      referral_source: 'patient' | 'hcp';
      linked_with: string | undefined;
    }
  | {
      event: AnalyticsEventName.h_screen_viewed;
      screen: ConnectScreen;
    }
  | {
      event: AnalyticsEventName.h_referral_url_copied;
      url: string;
    }
  | {
      event: AnalyticsEventName.h_referral_url_failed;
      type: REFERRAL_URL_TYPE;
      error: string;
    }
  | {
      event: AnalyticsEventName.h_referral_url_opened;
      type: REFERRAL_URL_TYPE;
    }
  | {
      event: AnalyticsEventName.p_app_opened;
    }
  | {
      event: AnalyticsEventName.p_page_not_found;
      path: string;
    };
